import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import logo from "@/assets/logo.svg";

export function ProtectedRoute() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center bg-brand-canvas p-4 text-foreground">
        <div className="relative flex flex-col items-center">
          {/* Ornate spinning border */}
          <div className="absolute h-28 w-28 rounded-full border-t border-b border-gold animate-spin" />
          <div className="absolute h-24 w-24 rounded-full border-r border-l border-gold/45 animate-spin [direction:reverse]" />

          {/* Logo container */}
          <div className="z-10 flex h-20 w-20 items-center justify-center rounded-full bg-sidebar border border-gold/40 p-2 shadow-[0_0_20px_rgba(212,175,55,0.15)]">
            <img src={logo} alt="Subaashghor" className="h-14 w-14 rounded-full object-contain" />
          </div>
        </div>

        <div className="mt-8 text-center">
          <h2 className="font-display text-xl tracking-wider text-gold">সুবাসঘর</h2>
          <p className="mt-1 text-xs tracking-[0.3em] uppercase text-gold-soft">Subaashghor</p>
          <div className="ornate-divider mx-auto mt-3 w-24" />
          <p className="mt-3 text-xs text-muted-foreground animate-pulse">
            Establishing secure console link...
          </p>
        </div>
      </div>
    );
  }

  if (!user || user.role !== "admin") {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
